"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowRightIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.ArrowRightIcon = (0, react_1.forwardRef)(function ArrowRightIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.6302 7.53911C13.5288 7.43776 13.4484 7.31743 13.3935 7.185C13.3387 7.05257 13.3105 6.91064 13.3105 6.7673C13.3105 6.62396 13.3387 6.48202 13.3935 6.34959C13.4484 6.21716 13.5288 6.09684 13.6302 5.99548C13.7315 5.89412 13.8518 5.81372 13.9843 5.75887C14.1167 5.70401 14.2586 5.67578 14.402 5.67578C14.6915 5.67578 14.9691 5.79078 15.1738 5.99548L20.408 11.2308C20.6125 11.4353 20.7274 11.7128 20.7274 12.002C20.7274 12.2913 20.6125 12.5687 20.408 12.7733L15.1738 18.0075C14.9691 18.2122 14.6915 18.3272 14.402 18.3272C14.1125 18.3272 13.8349 18.2122 13.6302 18.0075C13.4255 17.8028 13.3105 17.5251 13.3105 17.2357C13.3105 16.9462 13.4255 16.6685 13.6302 16.4638L15.1716 14.9235C15.7518 14.3439 16.3955 13.8316 17.0905 13.3962L17.9054 12.8835L17.8542 12.8333L16.808 12.9828C16.297 13.0556 15.7815 13.092 15.2654 13.0918H4.58651C4.29719 13.0918 4.01971 12.9769 3.81513 12.7723C3.61054 12.5677 3.49561 12.2903 3.49561 12.0009C3.49561 11.7116 3.61054 11.4341 3.81513 11.2295C4.01971 11.025 4.29719 10.91 4.58651 10.91H15.2665C15.7827 10.9102 16.2981 10.947 16.8091 11.0202L17.8563 11.1697L17.9065 11.1184L17.0883 10.6057C16.3945 10.1705 15.7519 9.6585 15.1727 9.07948L13.6302 7.53911Z", fill: "currentColor" })));
});
